import { render, staticRenderFns } from "./ConfigurationWizardAdmin.vue?vue&type=template&id=58d4cac4&scoped=true&"
import script from "./ConfigurationWizardAdmin.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWizardAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationWizardAdmin.vue?vue&type=style&index=0&id=58d4cac4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d4cac4",
  null
  
)

export default component.exports